import React from 'react';
import { motion } from 'motion/react';

interface CookieBannerProps {
  onAcceptAll: () => void;
  onEssentialOnly: () => void;
  onCustomize: () => void;
}

export const CookieBanner: React.FC<CookieBannerProps> = ({
  onAcceptAll,
  onEssentialOnly,
  onCustomize,
}) => {
  const handleLearnMore = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    // Navigate to cookies page (using standard navigation or state in App.tsx if applicable)
    window.location.hash = '#cookies-policy';
    // If there is a path router, or we can just trigger cookie modal/page
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (isMobile) {
      window.location.href = '/legal/cookie';
    } else {
      window.open('/legal/cookie', '_blank');
    }
  };

  return (
    <motion.div
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: 100, opacity: 0 }}
      transition={{ type: 'spring', damping: 25, stiffness: 150 }}
      className="fixed bottom-0 left-0 right-0 z-50 bg-[#3a3430] border-t border-white/[0.06] p-6 md:p-8 text-white"
      id="eNvesta-cookie-banner"
    >
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        {/* Left Side: Content */}
        <div className="flex-1 space-y-2">
          <h3 className="text-[11px] font-bold uppercase tracking-[0.2em] text-white font-heading">
            Cookie Preferences
          </h3>
          <p className="text-[11px] text-white/60 font-medium leading-relaxed">
            We use essential cookies for login and security. Optional telemetry helps optimize reconnaissance algorithms and platform latency.{' '}
            <a
              href="/legal/cookie"
              onClick={handleLearnMore}
              className="text-[#F26522] hover:underline font-bold transition-colors cursor-pointer ml-1"
            >
              Learn more
            </a>
          </p>
        </div>

        {/* Right Side: Action Buttons */}
        <div className="flex flex-wrap items-center gap-3 shrink-0">
          <button
            onClick={onEssentialOnly}
            className="text-[9px] font-bold uppercase tracking-widest text-white/50 hover:text-white transition-colors py-2.5 px-4 rounded-lg font-heading cursor-pointer bg-transparent hover:bg-transparent"
            id="cookie-btn-essential-only"
          >
            Essential Only
          </button>
          
          <button
            onClick={onCustomize}
            className="text-[9px] font-bold uppercase tracking-widest border border-white/20 text-white hover:text-white rounded-lg py-2.5 px-4 transition-all duration-200 font-heading cursor-pointer bg-transparent hover:bg-transparent"
            id="cookie-btn-customize"
          >
            Customize
          </button>

          <button
            onClick={onAcceptAll}
            className="text-[9px] font-bold uppercase tracking-widest border border-[#F26522] text-[#F26522] hover:text-[#F26522]/80 rounded-lg py-2.5 px-6 transition-colors font-heading cursor-pointer bg-transparent hover:bg-transparent"
            id="cookie-btn-accept-all"
          >
            Accept All
          </button>
        </div>
      </div>
    </motion.div>
  );
};
